export var TravelerTags;
(function (TravelerTags) {
    TravelerTags["VIP"] = "VIP";
    TravelerTags["BAD_APPLE"] = "BAD_APPLE";
    TravelerTags["RED_FLAG"] = "RED_FLAG";
    TravelerTags["TRAVEL_AGENT"] = "TRAVEL_AGENT";
    TravelerTags["JUNK"] = "JUNK";
})(TravelerTags || (TravelerTags = {}));
